import React from "react";
import { Button, Stack, Typography } from "@mui/material";
import { GreyButton } from "components/Picklist/common/GreyButton";
import { OrderItem } from "hooks/useFulfillmentBatch";

interface PackChargerStepProps {
  onChargerPacked: () => void;
  onSkip: () => void;
  item: OrderItem;
}

export function PackChargerStep({ onChargerPacked, onSkip, item }: PackChargerStepProps) {
  const chargerRequired = item.charger !== "Do not include charger";

  return (
    <Stack direction="column" alignItems="center" gap={1} mt={2}>
      {chargerRequired && <Typography align="center">Is the pictured charger packed in the box?</Typography>}
      <Typography
        align="center"
        fontWeight={600}
        sx={{
          maxWidth: "80%",
          whiteSpace: "pre-line",
          mb: 2,
        }}
      >
        {item.charger}
      </Typography>
      <img
        src={`/chargers/${item.charger.replaceAll(" ", "-")}.png`}
        alt={`${item.charger} charger`}
        style={{
          maxWidth: "300px",
          height: "auto",
          marginBottom: "1rem",
        }}
      />
      <Button variant="contained" onClick={onChargerPacked}>
        {chargerRequired ? "yes, charger packed" : "Continue"}
      </Button>
      {chargerRequired && <GreyButton onClick={onSkip}>No, unable to pack</GreyButton>}
    </Stack>
  );
}
